export const WARDEN_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_scan-warden/artifacts/kxw5x5qw_image.jpeg";

export function Logo({ className = "", size = 28, showText = true }) {
  const box = size + 12;
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div
        aria-label="Warden"
        className="rounded-md bg-no-repeat shrink-0"
        style={{
          width: box,
          height: box,
          backgroundImage: `url(${WARDEN_LOGO_URL})`,
          backgroundSize: "230%",
          backgroundPosition: "50% 33%",
          boxShadow: "0 0 16px rgba(0,229,255,0.22)",
          border: "1px solid rgba(0,229,255,0.28)",
        }}
      />
      {showText && (
        <span
          className="font-heading font-bold tracking-tight text-white"
          style={{ fontSize: size * 0.72 }}
        >
          Warden
        </span>
      )}
    </div>
  );
}

export function LogoFull({ className = "", size = 120 }) {
  return (
    <img
      src={WARDEN_LOGO_URL}
      alt="Warden"
      width={size}
      height={size}
      className={`rounded-xl object-cover ${className}`}
      style={{ boxShadow: "0 0 30px rgba(0,229,255,0.18)" }}
    />
  );
}
